module.exports = __webpack_public_path__ + "img/logo.957bd38e.jpg";